import { z } from 'zod';

export const INVALID_ERR = 'Must contain only alphanumeric characters and underscores, and must not begin with a digit';
export const DO_NOT_BEGIN_WITH_DOUBLE_UNDERSCORE = 'Must not begin with `__`';
export const DO_NOT_BEGIN_WITH_DIGIT = 'Must not begin with a digit';
export const TOO_LONG = 'Must be less than 255 characters long';

const prometheusMetricRegex = /^[a-zA-Z_][a-zA-Z0-9_]*$/;

export const prometheusMetricSchema = z
  .string({
    errorMap: (issue, ctx) => {
      if (issue.code === 'invalid_string' && issue.validation === 'regex') {
        if (/^[0-9]/.test(ctx.data)) {
          return { message: DO_NOT_BEGIN_WITH_DIGIT };
        }
        return { message: INVALID_ERR };
      }
      return { message: ctx.defaultError };
    },
  })
  .max(255, TOO_LONG)
  .regex(prometheusMetricRegex)
  .refine((value) => !value.startsWith('__'), DO_NOT_BEGIN_WITH_DOUBLE_UNDERSCORE)
  .or(z.literal(''));
